<mat-form-field [appearance]="appearance" class="flex-auto w-full">
  <input
    class="flex-auto w-full"
    type="text"
    matInput
    [formControl]="formGroup.get(controlName)"
    [placeholder]="label"
  />
</mat-form-field>
